import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import ComingSoon from '../../../../commonComponent/ComingSoon';

function ChannelManagement() {
  const navigate = useNavigate(); // Initialize useNavigate for routing

  return (
    <div>
      <div className="p-6 bg-gray-100">
        <header className="flex justify-between items-center mb-3 bg-white p-3">
          <h1 className="text-black text-xl font-bold ml-2">Online Booking Engine</h1>
          <div className="flex space-x-6">
            <button
              onClick={() => navigate('/dashboard/core-modules/online-booking-engine')}
              className="btn"
            >
              Direct Booking Integration
            </button>
            <button
              onClick={() =>
                navigate('/dashboard/core-modules/online-booking-engine/channel-management')
              }
              className="btn text-black font-bold"
            >
              Channel Management
            </button>
            <button
              onClick={() =>
                navigate('/dashboard/core-modules/online-booking-engine/payment-gateway')
              }
              className="btn"
            >
              Payment Gateway Integration
            </button>
          </div>
        </header>
        <ComingSoon />
      </div>
    </div>
  );
}

export default ChannelManagement;
